$(function() {
	$('.js-form-page-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function(form) {
            form.submit();
        }
	});
});